import React from "react";
import {ModalInfoContentBottom} from "../../../../components/ui/Content";
import {Body1, ModalInfoDiscription} from "../../../../components/Font";
import {useTheme} from "styled-components";
import {useAppSelector} from "../../../../app/hooks";
import {InfoModal} from "../../../../ui/Modal/InfoModal";

export interface PersonalInfoProps {
    onGoEdit(): void

    onGoBack(): void
}

export const SocialNumberInfo = ({onGoEdit, onGoBack}: PersonalInfoProps) => {
    const Theme = useTheme()
    const {socialNumber} = useAppSelector(state => state.account)

    const content = () => {
        return <>
            <ModalInfoContentBottom>
                <ModalInfoDiscription color={Theme.color.secondary}>
                    Номер СНИЛС
                </ModalInfoDiscription>
                <Body1>
                    {socialNumber?.value || '—'}
                </Body1>
            </ModalInfoContentBottom>
        </>
    }
    return <InfoModal
        title={'СНИЛС (при наличии)'}
        content={content}
        onEdit={onGoEdit}
        onGoBack={onGoBack}
    />
}
